import { render, staticRenderFns } from "./Msgsend.vue?vue&type=template&id=1b362b21&scoped=true&"
import script from "./Msgsend.vue?vue&type=script&lang=js&"
export * from "./Msgsend.vue?vue&type=script&lang=js&"
import style0 from "./Msgsend.vue?vue&type=style&index=0&id=1b362b21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b362b21",
  null
  
)

export default component.exports